// Shared easing + formatting used across the use-case scenes.
export const EASE = [0.16, 1, 0.3, 1] as const;

export const usd = (v: number) => `$${Math.round(v).toLocaleString("en-US")}`;

// The fictional studio used consistently across every scene's demo content.
export const BRAND = "Fitt Pilates";
export const BRAND_LOGO = "/images/website/fitt-pilates.jpg";
